import { makeAutoObservable, runInAction } from "mobx";
import { RootStore, ServiceStore } from "@intrasync/stores";
import { Job } from "types/common/ServiceStoreTypes";
import { PurchaseOrder } from "types/PurchaseOrderTypes";

export class ProjectDetailsStore {
  rootStore: RootStore;

  loading = false;
  error: string | null = null;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, { rootStore: false });
  }

  // Async actions
  async loadProject(projectId: number) {
    this.loading = true;
    this.error = null;

    try {
      // Load from the jobs ServiceStore
      const jobStore = this.rootStore.jobStore as ServiceStore;
      await jobStore.get(projectId);

      runInAction(() => {
        this.loading = false;
      });
    } catch (error) {
      runInAction(() => {
        this.error =
          error instanceof Error
            ? error.message
            : "Failed to load project details";
        this.loading = false;
      });
      console.error("Failed to load project:", error);
    }
  }

  // Computed values
  get activeProjectId() {
    const currentProjectId = this.rootStore.routerStore?.params?.projectId;
    console.log("Getting activeProjectId:", currentProjectId);
    return currentProjectId;
  }
  get project(): Project | null {
    console.log("Getting project for activeProjectId:", this.activeProjectId);
    if (!this.activeProjectId) return null;
    const jobStore = this.rootStore.jobStore as ServiceStore;
    return (
      (jobStore.entities.find(
        (p: any) => p.id === this.activeProjectId
      ) as unknown as Project) || null
    );
  }

  get customer() {
    if (!this.project?.customerId) return null;
    const customersStore = this.rootStore.customersStore as ServiceStore;
    return (
      customersStore.entities.find(
        (c: any) => c.id === this.project.customerId
      ) || null
    );
  }

  get opportunity() {
    if (!this.project?.opportunityId) return null;
    const opportunitiesStore = this.rootStore
      .opportunitiesStore as ServiceStore;
    return (
      opportunitiesStore.entities.find(
        (o: any) => o.opportunityId === this.project.opportunityId
      ) || null
    );
  }

  get projectManager() {
    if (!this.project?.projectManagerId) return null;
    const contactsStore = this.rootStore.contactsStore as ServiceStore;
    return (
      contactsStore.entities.find(
        (c: any) => c.contactId === this.project.projectManagerId
      ) || null
    );
  }

  get purchaseOrders() {
    if (!this.activeProjectId) return [];
    const purchaseOrdersStore = this.rootStore
      .purchaseOrdersStore as ServiceStore;
    // return (
    //   purchaseOrdersStore.entities.filter(
    //     (po: any) => po.projectId === this.activeProjectId
    //   ) || []
    // );
    return purchaseOrdersStore.entities.filter(
      (po: any) =>
        (po as unknown as { accountId: number }).accountId ===
        this.project?.accountId
    ) as unknown as PurchaseOrder[];
  }
}

export default ProjectDetailsStore;
